import { createFileRoute, redirect } from '@tanstack/react-router';
import { Permission } from '../../features/auth';
import { ReleaseToDeconPage } from '../../features/release-to-decon';

export const Route = createFileRoute('/_auth/release-from-case')({
  staticData: {
    title: 'pages.releaseToDecon.title',
    description: 'pages.releaseToDecon.description',
  },
  beforeLoad: async ({ context }) => {
    const { isAuthenticated, hasPermission, isAdmin } = context.auth;

    if (!isAuthenticated) throw redirect({ to: '/' });
    if (!hasPermission(Permission.SPD_RELEASE) && !isAdmin()) throw redirect({ to: '/403' });
  },
  component: ReleaseToDeconPage,
});
